/** @format */

import React, { Component } from 'react';
import { Modal, Form, Icon, Header, Divider, Label } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import { debounce } from 'lodash';
import { database } from 'firebase';

@inject('ClientsStore')
@observer
class ClientEdit extends Component {
  constructor() {
    super();
    this.state = {
      mobilePhone: {
        error: null,
        loading: false,
      },
    };
  }

  debouncedDuplicatePhoneCheck = debounce(phone => {
    this.setState({
      mobilePhone: {
        error: null,
        loading: true,
      },
    });

    database()
      .ref('clients')
      .orderByChild('mobPhone')
      .once('value', snap => {
        const clientsArray = Object.values(snap.val()).filter(c => c.data);

        const duplicate = clientsArray.find(
          client => client.data.mobPhone === phone,
        );

        if (duplicate) {
          this.setState({
            mobilePhone: {
              error: intl.get('clients.cellphone_duplicate'),
              loading: false,
            },
          });
        } else {
          this.setState({
            mobilePhone: {
              error: null,
              loading: false,
            },
          });
        }
      });
  }, 1000);

  onMobileChange = (_, input) => {
    const { ClientsStore } = this.props;

    ClientsStore.handleClientInput(input.name, input.value);

    this.setState({
      mobilePhone: {
        error: null,
        loading: false,
      },
    });

    if (input.value.trim().length > 0) {
      this.debouncedDuplicatePhoneCheck(input.value);
      return;
    }

    this.debouncedDuplicatePhoneCheck.cancel();
  };

  render() {
    const { ClientsStore } = this.props;
    return (
      <Modal
        onClose={() => {
          ClientsStore.toggleEditClientForm();
        }}
        open={ClientsStore.clientsParams.clientEditForm.open}
      >
        <Modal.Content>
          <Header className="modal-header" as="h3">
            <small>
              <Icon name="user" />
            </small>
            {intl.get('clients.edit_title')}
          </Header>
          <div className="header-spacer"></div>
          <Form
            className="modal-form"
            size="small"
            onSubmit={() =>
              ClientsStore.handleClientSubmit(
                ClientsStore.clientsParams.currentClientId,
              )
            }
          >
            <Header as="h5">
              <small>
                <Icon name="id card" />
              </small>
              {intl.get('clients.personal_data')}
            </Header>
            <Divider />
            <Form.Group widths="equal">
              <Form.Input
                disabled
                name="name"
                value={ClientsStore.currentClient.data.name}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.name')}
                placeholder={intl.get('clients.name')}
              ></Form.Input>
              <Form.Input
                disabled
                name="surname"
                value={ClientsStore.currentClient.data.surname}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.surname')}
                placeholder={intl.get('clients.surname')}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="plate"
                value={ClientsStore.currentClient.data.plate}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.license_plate')}
                placeholder={intl.get('clients.license_plate')}
              ></Form.Input>
              <Form.Input
                name="fiscalCode"
                value={ClientsStore.currentClient.data.fiscalCode}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.fiscal_code')}
                placeholder={intl.get('clients.fiscal_code')}
              ></Form.Input>
              <Form.Input
                name="vatNumber"
                value={ClientsStore.currentClient.data.vatNumber}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.vat_number')}
                placeholder={intl.get('clients.vat_number')}
              ></Form.Input>
            </Form.Group>
            <Header as="h5">
              <small>
                <Icon name="at" />
              </small>
              {intl.get('clients.contacts')}
            </Header>
            <Divider />
            <Form.Group widths="equal">
              <Form.Input
                name="email"
                value={ClientsStore.currentClient.data.email}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.email')}
                placeholder={intl.get('clients.email')}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="landPhone"
                value={ClientsStore.currentClient.data.landPhone}
                onChange={(e, input) =>
                  ClientsStore.handleClientInput(input.name, input.value)
                }
                fluid
                label={intl.get('clients.landphone')}
                placeholder={intl.get('clients.landphone')}
              ></Form.Input>
              <Form.Field>
                <Form.Input
                  name="mobPhone"
                  value={ClientsStore.currentClient.data.mobPhone}
                  onChange={this.onMobileChange}
                  fluid
                  label={intl.get('clients.cellphone')}
                  placeholder={intl.get('clients.cellphone')}
                  error={this.state.mobilePhone.error !== null}
                  loading={this.state.mobilePhone.loading}
                ></Form.Input>
                {this.state.mobilePhone.error && (
                  <Label pointing basic color="red">
                    {this.state.mobilePhone.error}
                  </Label>
                )}
              </Form.Field>
            </Form.Group>
            <Divider />
            <Form.Button type="submit" color="green" fluid size="small">
              <Icon name="save" /> {intl.get('general.save_updates')}
            </Form.Button>
          </Form>
        </Modal.Content>
        <div
          className="close-button"
          onClick={() => {
            ClientsStore.toggleEditClientForm();
          }}
        >
          X
        </div>
      </Modal>
    );
  }
}

export default ClientEdit;
